import type { ProductionTier } from '../types/voip';

/** Ordered high → low; a score lands in the first tier whose min it meets */
export const productionTiers: ProductionTier[] = [
  { id: 'pacesetter', label: 'Pacesetter', min: 75, range: '75+', dot: 'bg-positive', badge: 'bg-positive/10 text-positive' },
  { id: 'climbing', label: 'Climbing', min: 60, range: '60–74', dot: 'bg-bright', badge: 'bg-bright/10 text-bright' },
  { id: 'steady', label: 'Steady', min: 45, range: '45–59', dot: 'bg-accent-light', badge: 'bg-accent-soft text-accent' },
  { id: 'coaching', label: 'Coaching', min: 0, range: 'Under 45', dot: 'bg-warning', badge: 'bg-warning/10 text-warning' },
];
